import React from "react";
import { useEffect, useState } from "react";
import Header from "./layout/HeaderQR";
import Footer from "./layout/Footer";
import { url, verificationAPI } from "../utility/services/apiService";

function VerificationQR() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleUserPool = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const applicationId = urlParams.get("search");

      if (!applicationId) {
        console.error("No ApplicationId found in the URL");
        setLoading(false);
        return;
      }

      try {
        const result = await verificationAPI(
          { ApplicationId: applicationId },
          "check_etd"
        );
        setData(result?.data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    handleUserPool();
  }, []);

  return (
    <>
      <Header />
      <div className="container">
        <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
          <div
            className="col-lg-12 col-md-12 col-sm-12 col-xs-12 "
            style={{ marginTop: "5px", paddingRight: "1px" }}
          >
            <div className="tab-registration-content active">
              <input type="hidden" name="_csrf" value="" />
              <div className="card">
                <div className="box panel2 panel-default">
                  <div className="box-header with-border panel-heading">
                    <i className="fa fa-user"></i>{" "}
                    <h3 className="box-title">Verify Information Here</h3>
                  </div>
                  <div className="box-body panel-body">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="row" style={{ textAlign: "center" }}>
                          {data?.Photo ? (
                            <img
                              src={
                                data?.Photo.startsWith("data:image")
                                  ? data?.Photo
                                  : data?.Photo.length > 100
                                    ? `data:image/png;base64,${data?.Photo}`
                                    : `${url}get_file?path=${data?.Photo}`
                              }
                              className="img-thumbnail center-block declaration-image"
                              style={{
                                width: "110px",
                                height: "130px",
                              }}
                              alt="Applicant"
                              onError={(e) =>
                                console.error(
                                  "Image failed to load:",
                                  e.target.src
                                )
                              }
                            />
                          ) : (
                            <p>No image available</p>
                          )}
                        </div>
                      </div>
                      <div
                        className="col-sm-12"
                        style={{ textAlign: "center" }}
                      >
                        <b>{data?.FullName}</b>
                        <br />
                        <b>{data?.DateOfBirth}</b>, <b>{data?.Gender}</b>
                      </div>
                    </div>
                    <div className="strike">
                      <span>
                        <b>Document Information</b>
                      </span>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <div className="row">
                          <div className="col-sm-3">
                            <span style={{ lineHeight: "1.7em" }}>
                              <b style={{ fontSize: "13px" }}>ETD NO:</b>
                              <br />
                              <p
                                style={{
                                  fontSize: "13px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {data?.ETDNumber}
                              </p>
                            </span>
                          </div>
                          <div className="col-sm-3">
                            <span style={{ lineHeight: "1.7em" }}>
                              <b style={{ fontSize: "13px" }}>Printed by:</b>
                              <br />
                              <p
                                style={{
                                  fontSize: "13px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {data?.IssuedAt}
                              </p>
                            </span>
                          </div>
                          <div className="col-sm-3">
                            <span style={{ lineHeight: "1.7em" }}>
                              <b style={{ fontSize: "13px" }}>
                                Issued Date:
                              </b>
                              <br />
                              <p
                                style={{
                                  fontSize: "13px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {data?.IssuedDate}
                              </p>
                            </span>
                          </div>
                          <div className="col-sm-3">
                            <span style={{ lineHeight: "1.7em" }}>
                              <b style={{ fontSize: "13px" }}>
                                Expired Date:
                              </b>
                              <br />
                              <p
                                style={{
                                  fontSize: "13px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {data?.ExpiredDate}
                              </p>
                            </span>
                          </div>
                        </div>
                        <br />
                        <div className="strike">
                          <span>
                            <b>Payment Information:</b>
                          </span>
                        </div>
                        <div className="row">
                          <div className="col-sm-3">
                            <span style={{ lineHeight: "1.7em" }}>
                              <b style={{ fontSize: "13px" }}>
                                Payment No.:
                              </b>
                              <br />
                              <p
                                style={{
                                  fontSize: "13px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {data?.PaymentControlNo}
                              </p>
                            </span>
                          </div>
                          <div className="col-sm-3">
                            <span style={{ lineHeight: "1.7em" }}>
                              <b style={{ fontSize: "13px" }}>
                                Receipt No:
                              </b>
                              <br />
                              <p
                                style={{
                                  fontSize: "13px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {data?.PaymentReceipt}
                              </p>
                            </span>
                          </div>
                          <div className="col-sm-3">
                            <span style={{ lineHeight: "1.7em" }}>
                              <b style={{ fontSize: "13px" }}>
                                Payment Date:
                              </b>
                              <br />
                              <p
                                style={{
                                  fontSize: "13px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {data?.PaymentDate}
                              </p>
                            </span>
                          </div>
                          <div className="col-sm-3">
                            <span style={{ lineHeight: "1.7em" }}>
                              <b style={{ fontSize: "13px" }}>ETD Status:</b>
                              <br />
                              <p
                                style={{
                                  fontSize: "13px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {data?.NowStatus}
                              </p>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VerificationQR;
